var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drawer",class:[
		{
			'--open': _vm.isOpen,
			'--small': _vm.small,
			'--border-sandwich': _vm.borderSandwich
		},
		_vm.bgColor ? `bg--${_vm.bgColor}` : ''
	]},[_vm._t("before-title"),_vm._v(" "),_c('h3',{class:[
			_vm.small ? 'h6' : '',
			'drawer-title',
			_vm.bgColor ? `bg--${_vm.bgColor}` : ''
		]},[_c('button',{staticClass:"button--unstyled",attrs:{"aria-expanded":_vm.isOpen ? 'true' : 'false',"type":"button","id":`drawerTrigger${_vm.drawerId}`,"aria-controls":`drawerContent${_vm.drawerId}`},on:{"click":_vm.toggleDrawer}},[_vm._t("title",function(){return [_vm._v("Drawer title")]}),_vm._v(" "),_c('span',{staticClass:"icon icon-down"},[_c('span',{staticClass:"visually-hidden"},[_vm._v(_vm._s(_vm.buttonIconText))])])],2)]),_vm._v(" "),_c('transition-expand',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],staticClass:"drawer-content",attrs:{"id":`drawerContent${_vm.drawerId}`,"aria-labelledby":`drawerTrigger${_vm.drawerId}`,"role":"region"}},[_vm._t("content",function(){return [_vm._v("Drawer contents go here")]})],2)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }